import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LoadingIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  & > div {
    flex: 0 1 auto;
    text-align: center;
  }
`;

function LoadingIcon() {
  return (
    <LoadingIconWrapper>
      <div>
        <FontAwesomeIcon icon="spinner" spin size="5x" />
      </div>
    </LoadingIconWrapper>
  );
}

export default LoadingIcon;
